import { createContext, useContext } from 'react';

export interface SimulatedRole {
  name: string;
  permissionKeys: string[];
}

export interface PermissionsContextValue {
  /** Permisos efectivos (los del rol simulado si se está simulando, si no los reales). */
  permissions: string[];
  hasPermission: (key: string) => boolean;
  isOwner: boolean;
  /** True mientras se previsualiza la app con el set de permisos de un rol. */
  isSimulating: boolean;
  simulatingRoleName: string | null;
  simulate: (role: SimulatedRole) => void;
  stopSimulating: () => void;
}

export const PermissionsContext = createContext<PermissionsContextValue | undefined>(undefined);

export function usePermissions(): PermissionsContextValue {
  const ctx = useContext(PermissionsContext);
  if (ctx === undefined) {
    throw new Error('usePermissions must be used within PermissionsProvider');
  }
  return ctx;
}
